import { useCallback, useEffect, useState } from 'react';
import ApiSelector from '../components/ApiSelector';
import InputSection from '../components/InputSection';
import RootLayout from '../components/Layout';
import PromptForm from '../components/PromptForm';
import VideoTable from '../components/VideoTable';
import { useAppSelector } from '../store/hooks';

const Home = () => {
    const { videoSelected } = useAppSelector((state) => state.video);

    const [provider, setProvider] = useState('minimax');
    const [description, setDescription] = useState('');
    const [reloadKey, setReloadKey] = useState(0);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [videoKey, setVideoKey] = useState(0);
    const [previews, setPreviews] = useState([]);
    const [minimaxMode, setMinimaxMode] = useState('image');
    const [image, setImage] = useState({
        fileId: '',
        thumbnail: '',
    });

    useEffect(() => {
        if (videoSelected && videoSelected.description) {
            setDescription(videoSelected.description);
        }
        setImage({
            fileId: videoSelected.fileId,
            thumbnail: videoSelected.thumbnail,
        });
    }, [videoSelected]);

    const handleAccountChange = useCallback(() => {
        setReloadKey((prev) => prev + 1);
    }, []);

    const handleClearVideos = useCallback(() => {
        setVideoKey((prev) => prev + 1);
    }, []);

    const left = (
        <>
            <ApiSelector
                provider={provider}
                setProvider={setProvider}
                minimaxMode={minimaxMode}
                setMinimaxMode={setMinimaxMode}
            />
            <PromptForm
                provider={provider}
                minimaxMode={minimaxMode}
                setDescription={setDescription}
                reloadKey={reloadKey}
                selectedTitle={selectedTitle}
                setSelectedTitle={setSelectedTitle}
                setReloadKey={setReloadKey}
                onReload={handleAccountChange}
            />
            <InputSection
                provider={provider}
                minimaxMode={minimaxMode}
                setMinimaxMode={setMinimaxMode}
                description={description}
                setDescription={setDescription}
                title={selectedTitle}
                onReload={handleAccountChange}
                setPreviews={setPreviews}
                image={image}
            />
        </>
    );

    const right = (
        <VideoTable
            key={`${provider}-${videoKey}`}
            provider={provider}
            reloadKey={reloadKey}
            previews={previews}
        />
    );

    return (
        // <Layout
        //   left={left}
        //   right={right}
        //   onAccountChange={handleAccountChange}
        //   onClearVideos={handleClearVideos}
        // />
        <RootLayout
            left={left}
            right={right}
            onAccountChange={handleAccountChange}
            onClearVideos={handleClearVideos}
        />
    );
};

export default Home;
